import { Form, Input } from "antd-mobile";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useGetUserInfo } from "./hooks/profile.hook";
import "./style.scss";

function Profile() {
  const { t } = useTranslation();
  const form = useRef();
  const getUserInfo = useGetUserInfo({});
  useEffect(() => {
    if (getUserInfo.data) {
      form.current?.setFieldsValue({
        account: getUserInfo.data?.account,
        real_name: getUserInfo.data?.real_name,
        mobile:
          getUserInfo.data?.area_code && getUserInfo.data?.mobile
            ? `+${getUserInfo.data?.area_code} ${getUserInfo.data?.mobile}`
            : "-",
      });
    }
  }, [getUserInfo.data]);

  return (
    <div>
      <Form
        ref={form}
        layout="horizontal"
        initialValues={{ account: "-", real_name: "-", mobile: "-" }}
        className="profile-form"
      >
        <Form.Item name="account" label={t("personal.info.account")}>
          <Input readOnly />
        </Form.Item>
        <Form.Item name="real_name" label={t("personal.info.realName")}>
          <Input readOnly />
        </Form.Item>
        <Form.Item name="mobile" label={t("personal.info.mobile")}>
          <Input readOnly />
        </Form.Item>
      </Form>
    </div>
  );
}

export default Profile;
